import { businessesRelationship } from "./businessesRelationship";
import { contactReportsRelationship, contactReportsRelationshipEdit } from "./contactReportsRelationship";
import { contactsRelationship } from "./contactsRelationship";
import { donationEntriesRelationship } from "./donationEntriesRelationship";
import { filesRelationship } from "./filesRelationship";
import { involvementsRelationship, involvementsRelationshipEdit } from "./involvementsRelationship";
import { notesRelationship, notesRichTextRelationship } from "./notesRelationship";
import { propertiesOwnedRelationship } from "./propertiesOwnedRelationship";
import { propertiesRelationship } from "./propertiesRelationship";
import { propertyBusinessesRelationship, propertyBusinessesRelationshipEdit } from "./propertyBusinessesRelationship";
import { propertyUnitsRelationship, propertyUnitsRelationshipEdit } from "./propertyUnitsRelationship";
import { assignedTasksRelationship } from "./assignedTasksRelationship";
import { workplansRelationship } from "./workplansRelationship";
import { hoursRelationship } from "./hoursRelationship";
import { employeesRelationship } from "./employeesRelationship";
import { transformationStrategiesRelationship } from "./transformationStrategiesRelationship";
import { registriesRelationship } from "./registriesRelationship";
import { salesRelationship } from "./salesRelationship";
import { improvementsRelationship } from "./improvementsRelationship";
import { datesRelationship, datesRelationshipEdit } from "./datesRelationship";
import { timeSlotsRelationship, timeSlotsRelationshipEdit } from "./timeSlotsRelationship";
import { volunteerHoursRelationship, volunteerHoursRelationshipEdit } from "./volunteerHoursRelationship";
import { businessLocationsRelationship, businessLocationsRelationshipEdit } from "./businessLocationsRelationship";
import { jobsRelationship, jobsRelationshipEdit, jobsRelationshipPublic } from "./jobsRelationship";
import { donationScopeDonationEntriesRelationship } from "./donationScopeDonationEntriesRelationship";
import { eventsRelationship } from "./eventsRelationship";
import { tasksRelationship } from "./tasksRelationship";

// NOTE: Do not declare any new relationships here. Each relationship needs it's own file in @api/schema/

export const supportedRelationships = {
    contacts: contactsRelationship,
    businesses: businessesRelationship,
    properties: propertiesRelationship,
    workplans: workplansRelationship,
    events: eventsRelationship,

    owned_properties: propertiesOwnedRelationship,

    property_businesses: propertyBusinessesRelationship,
    property_businesses_edit: propertyBusinessesRelationshipEdit,

    property_units: propertyUnitsRelationship,
    property_units_edit: propertyUnitsRelationshipEdit,

    donation_entries: donationEntriesRelationship,

    involvements: involvementsRelationship,
    involvements_edit: involvementsRelationshipEdit,

    files: filesRelationship,
    notes: notesRelationship,
    richtext: notesRichTextRelationship,

    contact_reports: contactReportsRelationship,
    contact_reports_edit: contactReportsRelationshipEdit,

    workplan_tasks: assignedTasksRelationship,
    hours: hoursRelationship,
    employees: employeesRelationship,
    transformation_strategies: transformationStrategiesRelationship,
    registries: registriesRelationship,
    sales: salesRelationship,
    improvements: improvementsRelationship,

    tasks: tasksRelationship,

    dates: datesRelationship,
    dates_edit: datesRelationshipEdit,

    time_slots: timeSlotsRelationship,
    time_slots_edit: timeSlotsRelationshipEdit,

    volunteer_hours: volunteerHoursRelationship,
    volunteer_hours_edit: volunteerHoursRelationshipEdit,

    business_locations: businessLocationsRelationship,
    business_locations_edit: businessLocationsRelationshipEdit,

    jobs: jobsRelationship,
    jobs_edit: jobsRelationshipEdit,
    jobs_public: jobsRelationshipPublic,

    donation__donation_entries: donationScopeDonationEntriesRelationship,
};
